import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

import { Icon } from '../../Atoms/Icon';

const customModalHeader = ({ children, onHide, centered = false }) => {
  return (
    <Modal.Header className="border-0" style={{ paddingBottom: '0.75rem' }}>
      <Modal.Title className="w-100">
        <div className="d-flex justify-content-between">
          <div
            style={{
              marginTop: '4px',
              marginRight: '-28px',
              paddingLeft: centered ? '36px' : '12px',
              paddingRight: '36px',
              lineHeight: '2rem',
              textAlign: centered ? 'center' : '',
              wordBreak: 'break-word',
            }}
            className="w-100 font-weight-normal"
          >
            {children}
          </div>
          <div className="text-right pl-0 pr-2">
            <Icon
              onClick={() => onHide(false)}
              name="multiply"
              className="small text-gray-500"
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
      </Modal.Title>
    </Modal.Header>
  );
};

const customModalBody = ({ children }) => {
  return <Modal.Body style={{ padding: '1.75rem' }}>{children}</Modal.Body>;
};
const CustomModal = ({ modal, onHide, children, ...props }) => {
  return (
    <Modal show={modal} onHide={() => onHide(false)} {...props}>
      {children}
    </Modal>
  );
};

const customModalFooter = ({ children }) => {
  return (
    <Modal.Footer className="d-flex justify-content-center border-0 pb-5 pt-2">
      {children}
    </Modal.Footer>
  );
};
CustomModal.Header = customModalHeader;
CustomModal.Body = customModalBody;
CustomModal.Footer = customModalFooter;

CustomModal.propTypes = {
  children: PropTypes.node,
  modal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default CustomModal;
